import { render } from "./HeaderTitle.vue?vue&type=template&id=29852e54&scoped=true"
import script from "./HeaderTitle.vue?vue&type=script&lang=js"
export * from "./HeaderTitle.vue?vue&type=script&lang=js"

import "./HeaderTitle.vue?vue&type=style&index=0&id=29852e54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29852e54"]])

export default __exports__